import { makeAutoObservable } from "mobx";
export interface NetSuitePaymentType {
	id: number;
	name: string;
	prologueCode: string;
	netSuiteName: string;
	isActive: boolean;
	customerRequired: boolean;
	sendToNetSuite: boolean;
}

export class NetSuitePaymentTypeModel implements NetSuitePaymentType {
	id: number;
	name: string;
	prologueCode: string;
	netSuiteName: string;
	isActive: boolean;
	customerRequired: boolean;
	sendToNetSuite: boolean;

	constructor(netsuitePaymentType: NetSuitePaymentType) {
		makeAutoObservable(this);
		this.id = netsuitePaymentType.id;
		this.name = netsuitePaymentType.name;
		this.prologueCode = netsuitePaymentType.prologueCode;
		this.netSuiteName = netsuitePaymentType.netSuiteName;
		this.customerRequired = netsuitePaymentType.customerRequired;
		this.sendToNetSuite = netsuitePaymentType.sendToNetSuite;
		this.isActive = netsuitePaymentType.isActive ?? true;
	}
	get canSave() {
		return Boolean(this.name.trim());
	}
	setName(name: string) {
		this.name = name;
	}
	setPrologueCode(prologueCode: string) {
		this.prologueCode = prologueCode;
	}
	setNetSuiteName(netSuiteName: string) {
		this.netSuiteName = netSuiteName;
	}
	setCustomerRequired(custRequired: boolean) {
		this.customerRequired = custRequired;
	}
	setSendToNetSuite(sendToNS: boolean) {
		this.sendToNetSuite = sendToNS;
	}
}